import { render, staticRenderFns } from "./PetugasBankSoalAktif.vue?vue&type=template&id=1e1e2ecc&"
import script from "./PetugasBankSoalAktif.vue?vue&type=script&lang=js&"
export * from "./PetugasBankSoalAktif.vue?vue&type=script&lang=js&"
import style0 from "./PetugasBankSoalAktif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports